import { createReducer, on } from '@ngrx/store';
import {
  addCountToBasket,
  addToBasket,
  deleteFromBasket,
  removeFromBasket,
  resetBasket
} from '../actions/basket.actions';

export const basket = {};

export const basketReducer = createReducer(
  basket,
  on(addToBasket, (state, { uid, itemId, item, actualItem }) => {
    const _basket = JSON.parse(JSON.stringify(state));
    if (_basket[uid] && _basket[uid][itemId] && _basket[uid][itemId][item]) {
      _basket[uid][itemId][item]['count'] += 1;
    } else {
      if (!_basket[uid]) {
        _basket[uid] = {};
      }
      if (!_basket[uid][itemId]) {
        _basket[uid][itemId] = {};
      }
      _basket[uid][itemId][item] = {
        count: 1,
        id: item,
        actualItem,
      };
    }
    return _basket;
  }),
  on(addCountToBasket, (state, { uid, itemId, item, actualItem, count }) => {
    const _basket = JSON.parse(JSON.stringify(state));
    if (_basket[uid] && _basket[uid][itemId] && _basket[uid][itemId][item]) {
      _basket[uid][itemId][item]['count'] = count;
    } else {
      if (!_basket[uid]) {
        _basket[uid] = {};
      }
      if (!_basket[uid][itemId]) {
        _basket[uid][itemId] = {};
      }
      _basket[uid][itemId][item] = {
        count,
        actualItem,
        id: item,
      };
    }
    return _basket;
  }),
  on(removeFromBasket, (state, { uid, itemId, item }) => {
    const _basket = JSON.parse(JSON.stringify(state));
    if (_basket[uid] && _basket[uid][itemId] && _basket[uid][itemId][item]) {
      _basket[uid][itemId][item]['count'] -= 1;
    } else {
      if (!_basket[uid]) {
        _basket[uid] = {};
      }
      if (!_basket[uid][itemId]) {
        _basket[uid][itemId] = {};
      }
      _basket[uid][itemId][item] = {
        count: 1,
        id: item,
      };
    }
    return _basket;
  }),
  on(deleteFromBasket, (state, { uid, itemId, item }) => {
    const _basket = JSON.parse(JSON.stringify(state));
    if (_basket[uid] && _basket[uid][itemId] && _basket[uid][itemId][item]) {
      delete _basket[uid][itemId][item];
    }
    return _basket;
  }),
  on(resetBasket, (state) => ({}))
);
